import React from 'react';

export default function NoEligibleSchoolsFound(): React.ReactElement {
  return (
    <>
      <h2>0 Eligible High Schools Found</h2>
      <p>
        Don&apos;t attend an eligible international high school? We are adding new international
        schools all the time! Sign up to be notified when new international schools are added to our
        list.
      </p>
      <a
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Sign Up for Alerts (Opens in new tab)"
        className="shared-button medium margin primary"
        href="https://raise.us8.list-manage.com/subscribe?u=93c652bd8d2d114a4c15f3ce0&id=426afb10a7"
      >
        Sign Up for Alerts
      </a>
    </>
  );
}
